export default "__VITE_ASSET__CsxAjdNW__"